import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class NotificationService {

  private api_url = CONFIGURATION.baseURL + 'notifications/';

  constructor(private _http: Http) { }

  getNotifications(data:any){
    return this._http.post(this.api_url + 'all', data)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }

  readNotifications(id:any, value:any) {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.api_url + `mark/${id}/${value}`, { headers: headers }).map((response: Response) => response.json())
  }
  
  markNotifications(data:any){
    return this._http.put(`${this.api_url}read-unread-all` , data)
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }

  getTaxyears(data:any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post( CONFIGURATION.baseServiceUrl + 'payrolloverviewdashboardservice/referenceData', data, { headers: headers })
      .map((response: Response) => response.json())
  }

  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
  
 
}



// WEBPACK FOOTER //
// ./src/app/notifications/notifications.service.ts